import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import EmptyStateCard from 'modules/_shared/components/EmptyStates/EmptyStateCard';

const PartnerBookMaintenanceWarning: FC = () => {
  const { t } = useTranslate();

  return (
    <EmptyStateCard
      mainMessage={t('PartnerBookMaintenanceTitle')}
      infoMessage={t('PartnerBookMaintenanceDescription')}
    />
  );
};

export default PartnerBookMaintenanceWarning;
